import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import BlowerFan from 'features/processFlowDiagrams/svg/compressors-iso/blower-fan.svg?react'
import CompressorCentrifugal from 'features/processFlowDiagrams/svg/compressors-iso/compressor-centrifugal.svg?react'
import CompressorDiaphragm from 'features/processFlowDiagrams/svg/compressors-iso/compressor-diaphragm.svg?react'
import CompressorEjector from 'features/processFlowDiagrams/svg/compressors-iso/compressor-ejector.svg?react'
import CompressorPiston from 'features/processFlowDiagrams/svg/compressors-iso/compressor-piston.svg?react'
import CompressorRing from 'features/processFlowDiagrams/svg/compressors-iso/compressor-ring.svg?react'
import CompressorRollerVane from 'features/processFlowDiagrams/svg/compressors-iso/compressor-roller-vane.svg?react'
import CompressorRotary from 'features/processFlowDiagrams/svg/compressors-iso/compressor-rotary.svg?react'
import CompressorScrew from 'features/processFlowDiagrams/svg/compressors-iso/compressor-screw.svg?react'
import CompressorTurbo from 'features/processFlowDiagrams/svg/compressors-iso/compressor-turbo.svg?react'
import CompressorVacuumPump from 'features/processFlowDiagrams/svg/compressors-iso/compressor-vacuum-pump.svg?react'
import React from 'react'

export const PID_COMPRESSORS_ISO_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'blower-fan',
    name: 'Blower, Fan',
    category: 'compressors-iso',
    svgContent: <BlowerFan />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'compressor-vacuum-pump',
    name: 'Compressor, Vacuum Pump',
    category: 'compressors-iso',
    svgContent: <CompressorVacuumPump />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'compressor-centrifugal',
    name: 'Compressor (Centrifugal)',
    category: 'compressors-iso',
    svgContent: <CompressorCentrifugal />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'compressor-diaphragm',
    name: 'Compressor (Diaphragm)',
    category: 'compressors-iso',
    svgContent: <CompressorDiaphragm />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'compressor-ejector',
    name: 'Compressor (Ejector)',
    category: 'compressors-iso',
    svgContent: <CompressorEjector />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'compressor-piston',
    name: 'Compressor (Piston)',
    category: 'compressors-iso',
    svgContent: <CompressorPiston />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'compressor-ring',
    name: 'Compressor (Ring)',
    category: 'compressors-iso',
    svgContent: <CompressorRing />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'compressor-roller-vane',
    name: 'Compressor (Roller Vane)',
    category: 'compressors-iso',
    svgContent: <CompressorRollerVane />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'compressor-rotary',
    name: 'Compressor (Rotary)',
    category: 'compressors-iso',
    svgContent: <CompressorRotary />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'compressor-screw',
    name: 'Compressor (Screw)',
    category: 'compressors-iso',
    svgContent: <CompressorScrew />,
    viewBox: '0 0 100 100',
  },
  {
    id: 'compressor-turbo',
    name: 'Compressor (Turbo)',
    category: 'compressors-iso',
    svgContent: <CompressorTurbo />,
    viewBox: '0 0 100 100',
  },
]
